import axios from 'axios'
import { localizedUrl} from '@/helpers'

const axiosInstance = axios.create({
    baseURL: import.meta.env.VITE_APP_API_URL
})

axiosInstance.$post = (url, data) =>
    new Promise((resolve, reject) => {
        axiosInstance
            .post(localizedUrl(url), data)
            .then(response => resolve(response))
            .catch(error => reject(error))
    })

axiosInstance.$get = (url) =>
    new Promise((resolve, reject) => {
        axiosInstance
            .get(localizedUrl(url))
            .then(response => resolve(response))
            .catch(error => reject(error))
    })

export default axiosInstance
